export default `
  query listBCObjects($boundedContextId: String!, $limit: Int, $nextToken: String) {
    listBCObjects(boundedContextId: $boundedContextId, limit: $limit, nextToken: $nextToken) {
      items {
        id
        boundedContextId
        filepath
        prompt
        contents
        draftContents
        tags
      }
      nextToken
    }
  }
`
